import $ from 'jquery';
import { Reveal } from 'foundation-sites/js/foundation.reveal';

/**
 * ImagesReveal module.
 * @module app.imagesReveal
 * @requires foundation.reveal
 */

class ImagesReveal {
  /**
   * Creates a new instance of ImagesReveal.
   * @class
   * @param {jQuery} element - jQuery objects which links to an image.
   * @param {Object} options - optional parameters for the Reveal plugin.
   */
  constructor(elements, options) {
    this.options = $.extend({}, Reveal.defaults, ImagesReveal.defaults,
                            options);

    // create a new modal element and Reveal plugin
    this.$modal = $('<div class="reveal image-reveal"></div>')
                    .appendTo($(document.body));
    this.reveal = new Reveal(this.$modal, this.options);

    // append a close button to the modal overlay
    this.$modal.parent('.reveal-overlay').append(`
      <button class="close-button" type="button" aria-label="Fermer" data-close>
        <span class="icon-close" aria-hidden="true"></span>
      </button>
    `);

    // handle events which need to reset modal's size
    this.$modal.on('open.zf.reveal', this._reflow.bind(this));
    $(window).on('resize', this._reflow.bind(this));

    // catch the click on the links
    this.handle(elements);
  }

  /**
   * Catches the 'click' event on each element and open its target into
   * the modal. Note that it must be an image.
   * @function
   */
  handle(elements) {
    var _this = this;

    elements.each(function() {
      var href = this.href;

      $(this).off('click.app.imagesReveal')
        .on('click.app.imagesReveal', function(ev) {
          ev.preventDefault();
          _this.open(href);
        });
    });
  }

  /**
   * Attempt to display an image into the modal, openning it on success or
   * redirecting to the given URL on error.
   */
  open(src) {
    var _this = this;

    function _open() {
      _this.$modal.html('<img src="' + src + '" />');
      _this.reveal.open();
    }

    function _redirect() {
      window.location.href = src;
    }

    // create and wait for the image to be loaded
    let image = new Image();
    $(image).one('load.app.imagesReveal', function() {
      $(this).off('error.app.imagesReveal');
      _open();
    });
    $(image).one('error.app.imagesReveal', function() {
      $(this).off('load.app.imagesReveal');
      _redirect();
    });
    image.src = src;
  }

  /**
   * Calculates and sets the modal size according to the image.
   * @private
   */
  _reflow() {
    let $img = this.$modal.find('img');
    if (!$img.length) {
      return false;
    }

    // retrieve image's properties
    let imgHeight = $img[0].naturalHeight,
        imgWidth = $img[0].naturalWidth,
        windowHeight = $(window).height(),
        outerHeight = windowHeight - this.options.vOffset * 2,
        outerWidth = $(window).width() - this.options.vOffset * 2,
        height, width;

    if (imgHeight > outerHeight) {
      height = outerHeight;
      width = (imgWidth * height) / imgHeight;
    } else {
      height = imgHeight;
      width = imgWidth;
    }

    // check the calculated width
    if (width > outerWidth) {
      width = outerWidth;
      height = (imgHeight * width) / imgWidth;
    }

    this.$modal.css({
      'height': height,
      'width': width,
      'top': (windowHeight - height) / 2
    });
  }
}

/**
 * Default options for the Reveal plugin.
 * @link http://foundation.zurb.com/sites/docs/reveal.html#js-options
 */
ImagesReveal.defaults = {
  animationIn: 'slide-in-down fast',
  animationOut: 'slide-out-up fast',
  vOffset: 10,
  hOffset: 'auto'
};

export { ImagesReveal };



// WEBPACK FOOTER //
// ./src/js/lib/app.imagesReveal.js